import firebase from "firebase";
import _ from "lodash";
import {getChildList} from "../utils/getChild";
import {getProjectByPlan} from "./plan";
import {filterObjects} from "../utils/filterJobs";
import dayjs from "dayjs";
import {isCache} from "../plugins/firebase";


const getObject = async (id, projectID, init = false, planID = null, versionID = null) => {
  let name;

  const subDoc = await getProjectByPlan(projectID, planID, versionID)
    .collection('objects').get()
  const objects = []

  subDoc.forEach((subDoc) => {
    const data = subDoc.data();
    objects.push({
      id: subDoc.id,
      name: data.name,
      objects: data.objects,
      index: data.index,
      parentId: data.parentId || undefined,
      isParent: data.isParent,
    });
  });

  const formatObjects = getChildList(objects);
  const object = formatObjects.find((o) => o.id === id);

  if (init) {
    return object;
  }

  return object.name;
}

export const fetchObjectsWithParent = async (id, projectID, planID = null, versionID = null) => {
  const obj = await getObject(id, projectID, true, planID, versionID);
  return {
    id: obj.id,
    name: obj.name,
    objects: obj.objects,
    parentId: obj.parentId || undefined,
    isParent: !!obj.isParent,
  }
}

export const getObjectOptions = async (id, permission = null, obj = {}, ignoreDefault, emptyLabel = 'Показать все') => {
  let result = [];

  const path = 'OBJECT_' + JSON.stringify({
    id, obj
  })

  const cache = localStorage.getItem(path);

  if (!cache || Number(JSON.parse(cache).expire) < dayjs().unix()) {
    let res = null;

    if (obj.version) {
      res = myFirestore
        .collection('projects')
        .doc(id)
        .collection('versions')
        .doc(obj.version)
    } else if (obj.plan) {
      res = myFirestore
        .collection('projects')
        .doc(id)
        .collection('plan')
        .doc(obj.plan)
    } else {
      res = myFirestore
        .collection('projects')
        .doc(id)
    }


    const objectsData = await res
      .collection('objects')
      .get();

    await objectsData.forEach((subDoc) => {
      const data = subDoc.data();
      result.push({
        id: subDoc.id,
        name: data.name,
        objects: data.objects,
        index: data.index,
        parentId: data.parentId || undefined,
        isParent: data.isParent,
      });
    });
    if(isCache) {
      localStorage.setItem(path, JSON.stringify({result, expire: dayjs().add(10, 'minute').unix()}))
    }
  } else {
    result = JSON.parse(localStorage.getItem(path)).result
  }

  let r = null;

  if (permission) {
    r = _.orderBy(filterObjects(getChildList(result), permission), 'index', ['asc']);
  } else {
    r = _.orderBy(getChildList(result), 'index', ['asc']);
  }

  if (ignoreDefault) {
    return r.map((r) => {
      return {
        label: r.name,
        value: r.id,
      };
    })
  }
  return [
    {
      label:  emptyLabel,
      value: null,
    },
    {
      label: 'Без объекта',
      value: 'all',
    },
    ...r.map((r) => {
      return {
        label: r.name,
        value: r.id,
      };
    })
  ];
}



// WEBPACK FOOTER //
// ./src/firestore/objects.js